import React, { useEffect, useState, useRef } from "react";
import FormStrip from "../../components/FormStrip";
import { useTranslation } from "react-i18next";
import {
  MainWrapper,
  PrimaryTab,
  PrimaryTabs,
  PrimaryTabsWrapper,
  StyledDivider,
  SubTab,
  SubTabs,
  SubTabsWrapper,
} from "../../components/StyledComponent";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import { BackButton, Loader, Toast } from "@egovernments/digit-ui-react-components";
import { useHistory } from "react-router-dom";
import { Card } from "@mui/material";
import ReactToPrint from "react-to-print";
import ButtonWrapper from "../../components/Button";
import SearchSummary from "./Step4";
import { citizenBaseUrl } from "../../components/data";
import useDepartmentSelector from "../../../TCPForms/hooks/useDepartmentSelector";
import getResidentialData from "../resedential-self/getResidentialData";
import SubStep1 from "./Step1/SubStep1";
import SubStep3 from "./Step1/SubStep3";
import SubStep4 from "./Step1/SubStep4";
import Step2 from "./Step2/Step2";
import getPropertyDetails from "./getPropertyDetails";
import TakeActionItem from "../../../../../../../templates/Forms/TakeActionItem";

const RegisterProperty = () => {
  const dispatch = useDispatch();
  const { initFormMTDocs, resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { t } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const { id } = useParams();
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(Digit.SessionStorage.get("RP_CURR_TAB") || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(Digit?.SessionStorage.get("RP_CURRENT_SUBTAB") || 0);
  const [createDataResponse, setCreateDataResponse] = useState({});
  const [showToast, setShowToast] = useState(null);
  const summaryRef = useRef();
  console.log("creatDataResponse", createDataResponse);
  const subTabLabels = [{ label: "Applicant Information" }, { label: "LTP Information" }, { label: "Plot Details" }];

  const { info: userInfo } = Digit.UserService.getUser();
  const info = Digit.UserService.getUser()?.info;
  const userType = info?.type;
  const isEmployee = userType === "EMPLOYEE";
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
    const { data: { BPA: { logoStore } = {} } = {}, isLoading: isLogoLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["logoStore"]);
  const { applicationData, isAppDataLoading } = getPropertyDetails(userInfo, applicationFlow);
  const Modal = useModal();
  const { data: { BPA: { Organizations: departmentList } = {} } = {}, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", [
    "Organizations",
  ]);
  const { data: { BPA: { LandUseVillageMasterData: villagesData } = {} } = {}, isLoading: isVillagesLoading } = Digit.Hooks.obps.useMDMS(
    tenantId,
    "BPA",
    ["LandUseVillageMasterData"]
  );
    const avpLogo = logoStore?.find((item) => item.code === "up.avp");
  const daLogo = logoStore?.find((item) => item.code === "up.da");
  const daList = departmentList?.filter((item) => item.Type === "DA");
  const avpList = departmentList?.filter((item) => item.Type === "AVP");
  function filterDepartmentsList(completeList) {
    const officeNames = completeList?.map((office) => ({ value: office.Name, label: office.Name }));
    return officeNames;
  }
  const officesList = applicationFlow === "DA" ? filterDepartmentsList(daList) : filterDepartmentsList(avpList);

  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_KYP", applicationData);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "FORMLANDUSE");
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    Digit.SessionStorage.get("FILE_NO");
    Digit.SessionStorage.get("OWNER_INFO");
  }, []);
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData) {
      const data = { ...params, ...formData };
      if (activeTab === 0 && selectedSubTab === 0 && !("additionalDetails" in params)) {
        data.businessService = "BPA_KYP_DA"
        Digit.OBPSService.createLandUseUP({ LandUse: data }, tenantId)
          .then((res) => {
            if (res?.LandUse?.length > 0) {
              onSelect("", { ...data, ...res.LandUse[0] }, true);
              setShowToast({
                error: false,
                message: `Application Created Successfully!`,
              });
              setSelectedSubTab(nextSubTab);
              Digit.SessionStorage.set("RP_CURRENT_SUBTAB", nextSubTab);
            }
          })
          .catch((e) => {
            Modal("Error", `${e?.response?.data?.Errors[0]?.message}`, "error");
          });
      } else {
        try {
          data.workflow = { action: "UPLOAD_DOC", assignes: null };
          updateApiCall.mutate(
            { LandUse: data },
            {
              onSuccess: (res) => {
                onSelect("", res?.LandUse?.[0]);
                setShowToast({ error: false, message: `Data has been saved successfully` });
                setSelectedSubTab(nextSubTab);
                Digit.SessionStorage.set("RP_CURRENT_SUBTAB", nextSubTab);
              },
              onError: () => {
                Modal("Update Error", "Something went wrong!!", "error");
              },
            }
          );
        } catch (error) {
          console.error(error);
          Modal("Update Error", "Something went wrong!!", "error");
        }
      }
    } else {
      setSelectedSubTab(nextSubTab);
      Digit.SessionStorage.set("RP_CURRENT_SUBTAB", nextSubTab);
    }
  };
  const handleTabChange = (nextTabNo, formData = null) => {
    if (formData) {
      const data = { ...params, ...formData };
        try {
          if (activeTab === 2) {
            console.log("insideActiveTab3", activeTab, nextTabNo);

            // data.workflow = { action: "FORWARD_TO_DEPARTMENT", assignes: null };
            let redirectUrl = "";
            let message = "";
            const riskType = formData?.riskType;
            const isLowRiskCase = formData?.riskType === "LOW";
            console.log("riskingTypeFrom", riskType, isLowRiskCase);
            const isSchemeType = formData?.descriptionOfLand?.schemeType === "Scheme";
            if (isLowRiskCase) {
              data.nocDetails = {};
            }
            if (activeTab === 2) {
              data.workflow = { action: "FORWARD_TO_DEPARTMENT", assignes: null };
              redirectUrl = "/digit-ui/citizen/profile";
              message = "Application Approved";
            }
            updateApiCall.mutate(
              { LandUse: data },
              {
                onSuccess: () => {
                  onSelect("", data);
                },
                onError: () => {
                  setShowToast({ error: true, message: `Something went wrong, please try again!` });
                },
              }
            );

              Modal(
                "Data has been saved successfully!",
                `Application <strong>${data?.applicationNo}</strong> Forwarded to Department Successfully!`,
                "success",
                redirectUrl
              );
            
            clearParams();
          } else {
            console.log("insideELseACTIVETAB", activeTab, nextTabNo);
            data.workflow = { action: "UPLOAD_DOC", assignes: null };
            updateApiCall.mutate(
              { LandUse: data },
              {
                onSuccess: () => {
                  onSelect("", data);

                  setActiveTab(nextTabNo);
                  Digit?.SessionStorage.set("RP_CURR_TAB", nextTabNo);
                },

                onError: () => {
                  setShowToast({ error: true, message: `Something went wrong, please try again!` });
                },
              }
            );
          }
        } catch (error) {
          setShowToast({ error: true, message: `Something went wrong, please try again!` });
        }
    } else {
      setActiveTab(nextTabNo);
      Digit?.SessionStorage.set("RP_CURR_TAB", nextTabNo);
    }
  };

  useEffect(() => {
    if (id && applicationData) {
      setParams(applicationData);
      if (applicationData?.documents?.length > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const handleDeclarationChange = (event) => {
    setDeclarationChecked(event.target.checked);
  };

  const renderContent = () => {
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return (
            <SubStep1
              formData={params}
              handleSubTabChange={handleSubTabChange}
              setFormData={setParams}
              applicationFlow={applicationFlow}
              initFormMTDocs={initFormMTDocs}
              officesList={officesList}
              setShowToast={setShowToast}
              isEmployee={isEmployee}
              userInfo={userInfo}
            />
          );
        case 1:
          return <SubStep3 formData={params} handleSubTabChange={handleSubTabChange} isEmployee={isEmployee} />;
        case 2:
          return <SubStep4 formData={params} handleSubTabChange={handleSubTabChange} handleTabChange={handleTabChange} isEmployee={isEmployee} />;
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return <Step2 formData={params} userInfo={userInfo} handleTabChange={handleTabChange} t={t} initFormMTDocs={initFormMTDocs} />;
    } else if (activeTab === 2 && params?.applicationNo) {
      return (
        <div>
          <Card style={{ marginTop: "20px" }}>
            <TakeActionItem formType={"formLandUse"} id={ params?.applicationNo} ref={summaryRef} logoData={applicationFlow == "DA" ? daLogo : avpLogo} />
            <div className="footerContainer">
              <div className="buttonWrapper">
                <ReactToPrint
                  trigger={() => (
                    <ButtonWrapper variant="contained" color="success" size="medium" label="Print" sx={{ backgroundColor: "#000" }}>
                      Print Summary
                    </ButtonWrapper>
                  )}
                  content={() => summaryRef.current}
                />
                <ButtonWrapper
                  variant="contained"
                  color="error"
                  size="medium"
                  label="Preview"
                  sx={{ backgroundColor: "#CCC" }}
                  onClick={() => {
                    handleTabChange(0);
                    handleSubTabChange(0);
                  }}
                />
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label="Submit"
                  type="submit"
                  sx={{ backgroundColor: "#000" }}
                  onClick={() => handleTabChange(4, params)}
                />
              </div>
            </div>
          </Card>
        </div>
      );
    }
  };

  if (isAppDataLoading && id && !applicationData) {
    return <Loader />;
  }
  if (applicationFlow === null) {
    return <DepartmentSelector />;
  }

  return (
    <MainWrapper>
      {/* <HeaderContent applicationFlow={applicationFlow} /> */}
      <BackButton />
      <FormStrip formName={"Know your plot"} />
      <PrimaryTabsWrapper>
        {/* Tabs Header */}
        <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
          <PrimaryTab label="Applicant Form" />
          <PrimaryTab label="Documents" />
          <PrimaryTab label="Summary" />
        </PrimaryTabs>
      </PrimaryTabsWrapper>
      <StyledDivider />
      {activeTab === 0 && (
        <SubTabsWrapper>
          <SubTabs
            value={selectedSubTab}
            onChange={(e, i) => handleSubTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabLabels?.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}
      {renderContent()}
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </MainWrapper>
  );
};

export default RegisterProperty;
